module.exports = __webpack_public_path__ + "static/media/spade.ec79c415.svg";